import { sanitizeString } from './sanitizeString';
export const sanitizeKeyword = ({ keyword, toLowerCase = true, }) => sanitizeString({
    string: keyword,
    trim: true,
    removeDuplicateSpaces: true,
    alphaNumericOnly: {
        charactersToKeep: ['-', '_', '(', ')', '.', '/', '&'],
        keepSpacesBetweenWords: true,
    },
    toLowerCase,
    onlyHyphenMinus: true,
});
export const keywordToProperCase = (keyword) => {
    const sanitized = sanitizeKeyword({ keyword, toLowerCase: false });
    const words = sanitized.split(' ').filter(Boolean);
    if (words.length === 0) {
        return '';
    }
    return words
        .map((word) => {
        if (word[0] === '(') {
            return word.toUpperCase();
        }
        return `${word[0].toUpperCase()}${word.substring(1)}`;
    })
        .join(' ');
};
//# sourceMappingURL=sanitizeKeyword.js.map